import { Ki67PointsWithData } from './ki67points-with-data.model';
export class Ki67Status {
  imageId: number = -1;
  annotationId: number = -1;
  requisitionId: string = '';
  allPoints: Ki67PointsWithData[] = [];
  positivePoints: Ki67PointsWithData[] = [];
  negativePoints: Ki67PointsWithData[] = [];
  ki67Index: number = -1;
  minIntensity: number = -Infinity;
  minSize: number = -Infinity;
}
